<template>
  <div class="sider_4">
    <div class="title">
      {{ cTagName }}
      <span class="more fr" @click="moreBtn"
        >{{ more }}<i :class="moreTag"></i
      ></span>
    </div>
    <div class="department">
      <ul :class="ulList">
        <li v-for="(item, index) in cOtherLeaders" :key="index">
          <div class="aOtherLeader" @click="searchLeader(item.ldr_doctitle)">
            <div class="pic" style="cursor: pointer">
              <img :src="item.ldzp" alt="" />
            </div>
            <div class="name">{{ item.ldr_doctitle }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-silder-leaders",
  components: {},
  props: {
    cTagName: {
      default: "相关领导",
    },
    cImgs: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cOtherLeaders: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      more: "展开",
      more2: "展开",
      moreTag: "down",
      moreTag2: "down",
      ulList: "ulUp",
      ulList2: "ulUp",
    };
  },
  watch: {},
  computed: {},
  methods: {
    moreBtn() {
      if (this.moreTag == "down") {
        this.moreTag = "up";
        this.more = "收起";
        this.ulList = "ulDown";
      } else {
        this.moreTag = "down";
        this.more = "展开";
        this.ulList = "ulUp";
      }
    },
    moreBtn2() {
      if (this.moreTag2 == "down") {
        this.moreTag2 = "up";
        this.more2 = "收起";
        this.ulList2 = "ulDown";
      } else {
        this.moreTag2 = "down";
        this.more2 = "展开";
        this.ulList2 = "ulUp";
      }
    },
    searchLeader(item) {
      this.$emit("func", item);
      // console.log(leader);
      // this.$store.commit("getSearchWord", leader);
      // this.$parent.$parent.test();
      // console.log(this.$root);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang='less' scoped>
.fr {
  float: right;
}
.sider_4 {
  width: 100%;
  .title {
    // width: 323px;
    // width: 365px;
    width: 100%;
    height: 24px;
    font-size: 16px;
    padding-bottom: 10px;
    font-weight: bold;
    .more {
      display: inline-block;
      width: 55px;
      height: 30px;
      font-size: 14px;
      line-height: 30px;
      cursor: pointer;
      font-weight: normal;
      color: rgb(1, 82, 147);
    }
    i {
      display: inline-block;
      width: 20px;
      height: 20px;
      top: 20%;
      position: relative;
    }
    .up {
      background-image: url(../../assets/img/up.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .down {
      background-image: url(../../assets/img/down.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .department {
    // width: 323px;
    width:100%;
    margin: 0 auto;
    margin-bottom: 30px;
    ul {
      margin: 0;
      padding: 0;
      overflow: hidden;

      li {
        display: inline-block;
        // width: 57px;
        width:24%;
        // height: 111px;
        height:120px;
        font-size: 14px;
        line-height: 24px;
        margin-right: 1%;
        .pic {
          // width: 57px;
          width:70px;
          // height: 75px;
          height:90px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .name {
          // width: 57px;
          height: 30px;
          // padding-left: 5px;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          width: 100%;
        }
        a {
          color: #333;
        }
      }
    }
    .ulUp {
      // height: 105px;
      height: 120px;
    }
    .ulDown {
      height: auto;
    }
  }
}
</style>